import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Media from 'react-media';
import config from './config';

const mapStateToProps = ({ responsive }) => ({
  responsive,
});

const Mobile = ({ responsive: { phone, tablet }, children }) => (
  <Media
    query={`(max-width: ${config.mobile.maxWidth}px)`}
    defaultMatches={phone || tablet}
    render={() => <>{children}</>}
  />
);

Mobile.propTypes = {
  responsive: PropTypes.shape({
    phone: PropTypes.bool.isRequired,
  }).isRequired,
};

export default connect(mapStateToProps)(Mobile);
